import React, { useContext, useState } from 'react';
import {
  CircularProgress, IconButton, IconButtonProps,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/CloudDownload';
import clsx from 'clsx';
import DocumentService from 'services/document';
import { FileData } from 'API';
import { DICTIONARY } from 'shared/constants';
import AlertContext from 'shared/contexts/AlertContext';

interface Props extends IconButtonProps {
  className?: string;
  file: FileData;
}

const IconDownloadButton: React.FC<Props> = (props: Props) => {
  const { className, file, ...otherProps } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [, setAlert] = useContext(AlertContext);

  const downloadHandler = async () => {
    setIsLoading(true);

    try {
      await DocumentService.downloadDocument(file);
    } catch {
      setAlert([DICTIONARY.DownloadError, 'error']);
    } finally {
      setIsLoading(false);
    }
  };

  if (!file.original) {
    return null;
  }

  return isLoading
    ? <CircularProgress />
    : (
      <IconButton
        className={clsx(className)}
        onClick={downloadHandler}
        title="Download"
        {...otherProps}
        size="large">
        <DownloadIcon />
      </IconButton>
    );
};

export default IconDownloadButton;
